import React, {Fragment} from 'react';
import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import FontAwesome5Icon from 'react-native-vector-icons/FontAwesome5';
import theme from '../../../../global/styles/legacy/theme';
import LottieView from 'lottie-react-native';
import {View, Text} from 'react-native';
import { Baratinhaz } from '../../../Interface/Baratinhaz';

interface CheckinWeeksProps {
  weeks: number; // número de semanas completas (de 0 a 4)
  points?: {
    diario: number;
    mensal: number;
    semanal: {
      primeira_semana: number;
      segunda_semana: number;
      terceira_semana: 30;
    };
  };
}

const CheckinWeeks: React.FC<CheckinWeeksProps> = ({weeks, points}) => {
  const totalWeeks = 4;
  const rangeCoins = {
    0: points?.semanal?.primeira_semana ?? 0,
    1: points?.semanal?.segunda_semana ?? 0,
    2: points?.semanal?.terceira_semana ?? 0,
    3: points?.mensal ?? 0,
  } as any;

  return (
    <WeeksContainer>
      {Array.from({length: totalWeeks}, (_, index) => (
        <Fragment key={index}>
          {index > 0 && <Separator filled={weeks > index} />}
          <WeekWrapper filled={index < weeks}>
            <Week
              style={{
                borderTopLeftRadius: index === 0 ? 4 : 0,
                borderBottomLeftRadius: index === 0 ? 4 : 0,
                borderTopRightRadius: index + 1 === totalWeeks ? 4 : 0,
                borderBottomRightRadius: index + 1 === totalWeeks ? 4 : 0,
              }}
              filled={index < weeks}>
              <Result filled={weeks > index}>
                {weeks > index ? (
                  <>
                    {/* @ts-ignore */}
                    <FontAwesome5Icon
                      name="check"
                      size={8}
                      color={theme.colors.background}
                    />
                  </>
                ) : (
                  <View
                    style={{
                      flexDirection: 'row',

                      alignItems: 'center',
                    }}>
                    <ResultText filled={weeks > index}>
                      +{index <= 3 && rangeCoins[index] as any}
                    </ResultText>
                    <Baratinhaz width={17} height={17} />
                  </View>
                )}
              </Result>
            </Week>
            <WeekLabel filled={index < weeks}>
              <WeekLabelText filled={index < weeks}>
                {index + 1}ª Semana
              </WeekLabelText>
            </WeekLabel>
          </WeekWrapper>
        </Fragment>
      ))}
    </WeeksContainer>
  );
};

const WeeksContainer = styled.View`
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const WeekWrapper = styled.View<{filled: boolean}>`
  padding: 4px;
  border-radius: 4px;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  background-color: ${({filled, theme}) =>
    filled ? theme.colors.primary : '#fcf0d2'};
`;

const Week = styled.View<{filled: boolean}>``;

const WeekLabel = styled.View<{filled: boolean}>`
  background-color: ${({filled, theme}) =>
    filled ? theme.colors.primary : '#fcf0d2'};
`;

const WeekLabelText = styled.Text<{filled: boolean}>`
  font-size: ${RFValue(9)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({filled, theme}) =>
    filled ? theme.colors.background : theme.colors.orange};
`;

const Separator = styled.View<{filled: boolean}>`
  width:  ${RFValue(8)}px;
  height: ${RFValue(2)}px;
  background-color: ${({filled, theme}) => (filled ? '#00c77e' : theme.colors.gold)};
`;

const Result = styled.View<{filled: boolean}>`
  color: ${({filled, theme}) => (filled ? theme.colors.background : '#fcf0d2')};
`;

const ResultText = styled.Text<{filled: boolean}>`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  margin-top: 1px;

  color: ${({filled, theme}) =>
    filled ? theme.colors.background : theme.colors.orange};
`;

export default CheckinWeeks;
